import { debounce } from "@/utils/CommonUtils";
import { useEffect } from "react";

export const useWindowResize = (callback: (resizing: boolean) => void) => {
  const handleResize = () => {
    callback(true);
    debounce(() => callback(false), 300)();
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    callback(false);
  }, []);
};
